import Vue from 'vue'
import Router from 'vue-router'
import ProductList from '@/components/ProductList'
import Page from '@/components/Page'
import VueTouch from 'vue2-touch-events'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

// You can also pass in the default options
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.use(Router)

Vue.use(VueTouch)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: ProductList
    },
    {
      path: '/:name',
      name: 'Page',
      component: Page
    },
    {
      path: '/products/:sub',
      name: 'Product',
      component: ProductList
    }
  ]
});
